import { GET_PROJECTS_LIST, GET_VENDOR_PROJECT_USERS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type VendorProjectUsers = {
  projectId: string;
  vendorUserId: string;
  userType: string;
  isActive: boolean | string;
  isUsed: boolean | string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const VenProUsersInitialValues = {
  projectId: "",
  vendorUserId: "",
  userType: "",
  isActive: null,
  isUsed: null,
  created_at: [null, null],
  updated_at: [null, null],
};

export const VenProUsersMandatoryFields = [];

export const VenProUsersValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const VenProUsersProperties = [
  {
    id: "projectId",
    type: "single-select-search",
    label: "Project",
    // list: "projects_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_PROJECTS_LIST,
    gqlKey: "getProjects",
    dataKey: "projects",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },

  {
    id: "userType",
    type: "normal-select",
    label: "User Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Licensed", value: "Licensed" },
      { label: "Basic", value: "Basic" },
    ],
    // hideNone: true,
  },
  {
    id: "isActive",
    type: "normal-select",
    label: "Is Active",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
  },
  {
    id: "isUsed",
    type: "normal-select",
    label: "Is Used",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
  },
  {
    id: "vendorUserId",
    type: "single-select-search",
    label: "Vendor User Email",
    keyValue: { label: "vendorEmail", value: "vendorUserId" },
    query: GET_VENDOR_PROJECT_USERS,
    gqlKey: "getVendorProjectUsers",
    dataKey: "vendorProjectUsers",
    searchFieldKey: "vendorEmail",
    dependentOn: ["projectId", "userType", "isActive", "isUsed"],
    strictDependency: false,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
